/**
 * FileName : eventBus.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-09-07 09:16:59
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


import { EventEmitter } from 'events';

export default new EventEmitter();
